/* Logo charges — every logo position is charged on every garment.
   Garment lines added through the Logo Studio carry "Logo positions" ("1. Left chest — DTF transfer · 2. Right chest — DTF transfer")
   and a hidden "_logo_ref" shared by all size lines of that add. For each ref this keeps matching "Logo decoration" lines in the cart:
   one line per decoration type, quantity = garments × positions of that type, plus a one-off embroidery setup line.
   Embroidery (4 Oct 2026): front / small positions (chest, sleeves, upper back, caps) = cfg.emb (up to 6,000 stitches),
   large positions (front centre, standard back, lower back) = cfg.emb_large (up to 15,000 stitches); setup = cfg.setup, charged
   once per embroidered design per order (designs come from the hidden "_emb_designs" property; older lines without it count as one).
   cfg.small / cfg.large (DTF) are optional: a store that does not charge DTF simply leaves them empty.
   Runs on page load and after every cart render, so changing or removing garments updates the charges. */
(function () {
  'use strict';
  var cfg = window.TT_DECO; if (!cfg || !(cfg.small || cfg.emb)) return;
  var LARGE = /front centre|standard back|lower back|full back|large/i;
  var busy = false, rounds = 0, again = false, pending = null, holdT = null, evT = null;

  function positions(str) {
    return String(str || '').split(' · ').map(function (p) {
      var t = p.replace(/^\s*\d+\.\s*/, '').split(' — ');
      return { label: (t[0] || '').trim(), method: (t[1] || '').trim() };
    }).filter(function (p) { return p.label && p.method && !/no decoration/i.test(p.method); });
  }
  function variantFor(p) {
    if (/embroid/i.test(p.method)) return LARGE.test(p.label) && cfg.emb_large ? cfg.emb_large : cfg.emb;
    return LARGE.test(p.label) ? (cfg.large || cfg.small) : cfg.small;
  }

  function wanted(cart) {
    var refs = {};
    cart.items.forEach(function (it) {
      var pr = it.properties || {};
      if (!pr._logo_ref || !pr['Logo positions'] || pr._deco_ref) return;
      if (!it.original_price) return; /* price-on-application garments are priced on the quote */
      var r = refs[pr._logo_ref] || (refs[pr._logo_ref] = { title: it.product_title, units: 0, pos: positions(pr['Logo positions']), designs: null });
      if (pr._emb_designs && !r.designs) r.designs = String(pr._emb_designs).split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      r.units += it.quantity;
    });
    var out = {}, seenDesigns = {};
    Object.keys(refs).forEach(function (ref) {
      var r = refs[ref], emb = false;
      r.pos.forEach(function (p) {
        var v = variantFor(p); if (/embroid/i.test(p.method)) emb = true;
        if (!v) return; /* this store does not charge that method */
        var k = ref + '|' + v, w = out[k] || (out[k] = { ref: ref, id: v, qty: 0, labels: [], title: r.title });
        w.qty += r.units; w.labels.push(p.label);
      });
      if (emb && cfg.setup) {
        /* one setup per embroidered design per order: a design already charged on another product in this cart is not charged again */
        var fresh = 1;
        if (r.designs && r.designs.length) { fresh = 0; r.designs.forEach(function (d) { if (!seenDesigns[d]) { seenDesigns[d] = 1; fresh++; } }); }
        if (fresh) out[ref + '|' + cfg.setup] = { ref: ref, id: cfg.setup, qty: fresh, labels: [fresh > 1 ? fresh + ' logos, one-off' : 'One-off per logo'], title: r.title };
      }
    });
    return out;
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }

  /* one sync at a time: a call during a sync re-runs it afterwards (and shares its promise); while the Logo Studio swaps a
     garment line (WWM.decoHold) syncing waits, because two cart writes at the same time can wipe each other out */
  function sync() {
    if (window.WWM && window.WWM.decoHold) { clearTimeout(holdT); holdT = setTimeout(sync, 400); return Promise.resolve(); }
    if (busy) { again = true; return pending || Promise.resolve(); }
    if (rounds > 4) return Promise.resolve();
    busy = true;
    pending = run().then(function () { busy = false; if (again) { again = false; return sync(); } });
    return pending;
  }
  function run() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var want = wanted(cart), updates = {}, changed = false, have = {};
      cart.items.forEach(function (it) {
        var pr = it.properties || {}; if (!pr._deco_ref) return;
        var k = pr._deco_ref + '|' + it.variant_id, w = want[k];
        if (!w || have[k]) { updates[it.key] = 0; changed = true; return; }
        have[k] = true;
        if (it.quantity !== w.qty) { updates[it.key] = w.qty; changed = true; }
      });
      var adds = Object.keys(want).filter(function (k) { return !have[k]; }).map(function (k) {
        var w = want[k];
        return { id: w.id, quantity: w.qty, properties: { For: w.title, Positions: w.labels.join(', '), _deco_ref: w.ref } };
      });
      if (!changed && !adds.length) { rounds = 0; return; }
      rounds++;
      var chain = Promise.resolve();
      if (changed) chain = chain.then(function () { return post('/cart/update.js', { updates: updates }); });
      if (adds.length) chain = chain.then(function () { return post('/cart/add.js', { items: adds }); });
      return chain.then(function () {
        if (window.WWM && WWM.cart && WWM.cart.update) return WWM.cart.update();
        if (/\/cart\/?$/.test(location.pathname)) location.reload();
      });
    }).catch(function () { });
  }

  window.TT_DECO.sync = sync;
  document.addEventListener('wwm:cart:rendered', function () { clearTimeout(evT); evT = setTimeout(sync, 600); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
